module.exports = __webpack_public_path__ + "static/media/cancel-payment-icon.23e04ae0.svg";